 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML01_HALF from '@/components/xhtml/01_Half'
 import XHTML02_DEDI from '@/components/xhtml/02_Dedi'
 import XHTML03_TITLE from '@/components/xhtml/03_Title'
 import XHTML04_COPYRIGHT from '@/components/xhtml/04_Copyright'
 import XHTMLTOC from '@/components/xhtml/Toc'
 import XHTML05_ACKNOWLEDGEMENTS from '@/components/xhtml/05_Acknowledgements'
 import XHTML06_INTRODUCTION from '@/components/xhtml/06_Introduction'
 import XHTML07_CHAPTER01 from '@/components/xhtml/07_Chapter01'
 import XHTML08_CHAPTER02 from '@/components/xhtml/08_Chapter02'
 import XHTML09_CHAPTER03 from '@/components/xhtml/09_Chapter03'
 import XHTML10_CHAPTER04 from '@/components/xhtml/10_Chapter04'
 import XHTML11_CHAPTER05 from '@/components/xhtml/11_Chapter05'
 import XHTML12_CHAPTER06 from '@/components/xhtml/12_Chapter06'
 import XHTML13_CHAPTER07 from '@/components/xhtml/13_Chapter07'
 import XHTML14_CHAPTER07A from '@/components/xhtml/14_Chapter07a'
 import XHTML15_CHAPTER08 from '@/components/xhtml/15_Chapter08'
 import XHTML16_CHAPTER09 from '@/components/xhtml/16_Chapter09'
 import XHTML17_CHAPTER10 from '@/components/xhtml/17_Chapter10'
 import XHTML18_CHAPTER11 from '@/components/xhtml/18_Chapter11'
 import XHTML20_CHAPTER12 from '@/components/xhtml/20_Chapter12'
 import XHTML21_APPENDIX01 from '@/components/xhtml/21_Appendix01'
 import XHTML22_APPENDIX02 from '@/components/xhtml/22_Appendix02'
 import XHTML23_APPENDIX03 from '@/components/xhtml/23_Appendix03'
 import XHTML24_NOTES from '@/components/xhtml/24_Notes'
 import XHTML25_BIBLIOGRAPHY from '@/components/xhtml/25_Bibliography'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/00_Cover",
 			"name" : "xhtml/00_Cover",
 			"component" : XHTML00_COVER
 		},
 		{
 			"path" : "/xhtml/01_Half",
 			"name" : "xhtml/01_Half",
 			"component" : XHTML01_HALF
 		},
 		{
 			"path" : "/xhtml/02_Dedi",
 			"name" : "xhtml/02_Dedi",
 			"component" : XHTML02_DEDI
 		},
 		{
 			"path" : "/xhtml/03_Title",
 			"name" : "xhtml/03_Title",
 			"component" : XHTML03_TITLE
 		},
 		{
 			"path" : "/xhtml/04_Copyright",
 			"name" : "xhtml/04_Copyright",
 			"component" : XHTML04_COPYRIGHT
 		},
 		{
 			"path" : "/xhtml/Toc",
 			"name" : "xhtml/Toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/05_Acknowledgements",
 			"name" : "xhtml/05_Acknowledgements",
 			"component" : XHTML05_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/xhtml/06_Introduction",
 			"name" : "xhtml/06_Introduction",
 			"component" : XHTML06_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/07_Chapter01",
 			"name" : "xhtml/07_Chapter01",
 			"component" : XHTML07_CHAPTER01
 		},
 		{
 			"path" : "/xhtml/08_Chapter02",
 			"name" : "xhtml/08_Chapter02",
 			"component" : XHTML08_CHAPTER02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js